<template>
    <div>
        <v-autocomplete
                label="شهر"
                v-model="city_id"
                :items="cities.filter((x)=>x.province_id===province_id)"
                item-text="name"
                item-value="id"
                clearable
                outlined
                required
                dense
                clear-icon="mdi-close-circle-outline"
                prepend-inner-icon="fa fa-pencil-alt"
                class="mt-1"
        ></v-autocomplete>
    </div>
</template>

<script>
import {Axios2, Bus} from "../../../main";

export default {
    name: "citySelector",
    data() {
        return {
            cities: [],
            city_id: undefined,
            province_id: undefined
        }
    },
    methods: {
        getCities() {
            Axios2.get('/cities').then((response) => {
                this.cities = response.data.data;
            })
        },
    },
    watch: {
        city_id: {
            handler: function (value) {
                Bus.$emit('getCity',value);
            }
        }
    },
    created() {
        this.getCities();

        Bus.$on("change_province", (value) => {
            this.province_id = value;
        });
    }
}
</script>

<style scoped>

</style>